// extracted by mini-css-extract-plugin
module.exports = {"socialMedia":"SocialMedia_socialMedia__3g1Sx","socialMediaNavBar":"SocialMedia_socialMediaNavBar__UPWBO"};